import {useEffect} from 'react'
import {type IntlShape, useIntl} from 'react-intl'

// TODO [sc-198186]: remove this file once RAA returns the translated room
// name, since room search tracking is its only user.
type FormatMessage = IntlShape['formatMessage']

let bridgedFormatMessage: FormatMessage | undefined

/**
 * `formatMessage` of the mounted `IntlProvider`, for code outside React such as
 * analytics middleware. Undefined until the provider has loaded its messages.
 */
export const getBridgedFormatMessage = (): FormatMessage | undefined =>
  bridgedFormatMessage

/** Render inside `IntlProvider` so middleware can translate tracked copy. */
export const FormatMessageBridge = () => {
  const {formatMessage} = useIntl()

  useEffect(() => {
    bridgedFormatMessage = formatMessage
  }, [formatMessage])

  return null
}
